const URL_TO_USE = 'fhittingroom';
// sandbox  - fhittingroom2.sandbox
// dev      - fhittingroom.
const DOMAIN = `https://${URL_TO_USE}.marianatek.com`;

// CHOOSEN_INSTRUCTOR_INFO - when we reserve an instructor we should call this url and add parameter in the end id of instructor which we choose

export default {
    URL_TO_USE: URL_TO_USE,
    DOMAIN: DOMAIN,
    DATA_REGIONS: {
        url: `${DOMAIN}/api/customer/v1/regions?page=1&page_size=500`,
        commitName: 'setRegions'
    },
    DATA_LOCATIONS: {
        url: `${DOMAIN}/api/customer/v1/locations?page=1&page_size=500`,
        commitName: 'setLocations'
    },
    DATA_CHOOSEN_REGION: {
        url: `${DOMAIN}/api/customer/v1/regions/48022/schedule_filters`,
        commitName: 'setChoosenRegion'
    },
    CHOOSEN_INSTRUCTOR_INFO:`${DOMAIN}/api/customer/v1/classes/`
}


// WEBPACK FOOTER //
// ./assets/js/modules/appConstants.js